import clsx from 'clsx';
import React, { ButtonHTMLAttributes } from 'react';

type Props = {
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  ghost?: boolean;
  white?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Button = React.forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { primary, secondary, tertiary, white, ghost, className, ...rest } = props;

  return (
    <button
      className={clsx(
        'button',
        {
          'button--primary': primary,
          'button--secondary': secondary,
          'button--ghost': ghost,
          'button--tertiary': tertiary,
          'button--white': white,
        },
        className,
      )}
      ref={ref}
      {...rest}
    />
  );
});

Button.displayName = 'Button';

export default Button;
